import{jsxs as t,jsx as o}from"react/jsx-runtime";import e from"styled-components";import{useTranslation as i}from"react-i18next";import r from"../../../../../assets/profileSettingsWhatsApp/android/call-icon.svg.js";import n from"../../../../../assets/profileSettingsWhatsApp/android/message-icon.svg.js";import s from"../../../../../assets/profileSettingsWhatsApp/android/video-icon.svg.js";import{getMessageDate as a}from"../../../../../utils/common.js";import{Divider as l,Wrapper as p}from"./styled.js";const c=e.p`
  font-size: 14px;
  font-weight: 400;
  color: rgb(0, 150, 136);
  margin: 0 0 8px 0;
`,d=e.p`
  font-size: 14px;
  font-weight: 400;
  color: rgb(21, 21, 21);
  margin: 0;
`,m=e.span`
  font-size: 12px;
  font-weight: 400;
  color: rgb(158, 158, 158);
`,g=e.p`
  font-size: 14px;
  font-weight: 400;
  color: rgb(21, 21, 21);
  margin: 0;
`,h=e.div`
  padding-bottom: 8px;
  margin-bottom: 8px;
  ${l}
`,f=e.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`,u=e.img`
  &:not(:last-child) {
    margin-right: 16px;
  }
`,x=({whatsappData:{values:e,placeholders:l}={values:{},placeholders:{}}})=>{const{t:x,i18n:b}=i(),v=a({messageDate:e.updated,opts:{year:"numeric"},locale:b.language}),j=`${e.countryCode?`+${e.countryCode}`:""} ${e.phone||l.phone||""}`;return t(p,{children:[o(c,{children:x("whatsapp.settings.title")}),t(h,{children:[o(d,{children:e.about||l.about}),o(m,{children:v})]}),t(f,{children:[t("div",{children:[o(g,{children:j}),o(m,{children:x("common.mobile")})]}),t("div",{children:[o(u,{alt:x("imgAlt.androidMessageIcon"),src:n}),o(u,{alt:x("imgAlt.androidCallIcon"),src:r}),o(u,{alt:x("imgAlt.androidVideoIcon"),src:s})]})]})]})};export{x as AboutSection};
//# sourceMappingURL=AboutSection.js.map
